import React from "react";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import exterior from "../assests/images/about.jpeg";
import showroom from "../assests/images/about1.jpeg";
import showroomVideo from "../assests/touzabillar.mp4";
import "./AboutScreen.css";

const stockUrl = "https://www.blocket.se/butik/touza-bilar";
const directionsUrl = "https://www.google.com/maps/dir/?api=1&destination=Wedav%C3%A4gen%204C%2C%20152%2042%20S%C3%B6dert%C3%A4lje";

const AboutScreen = () => (
  <>
    <NavBar />
    <main id="main-content" className="tb-about-page" tabIndex="-1">
      <section className="tb-about-hero tb-container" aria-labelledby="tb-about-title">
        <div className="tb-about-hero-copy">
          <p className="tb-eyebrow">OM TOUZA BILAR</p>
          <h1 id="tb-about-title">Ett familjeföretag.<br />En passion för bilar.</h1>
          <p className="tb-about-lead">Vi köper, säljer och byter bilar i Södertälje. Hos oss börjar varje bilaffär med dig och dina behov.</p>
          <p>Med över ett decennium i bilbranschen och en gemensam kärlek till bilar hjälper vi dig att hitta en bil som passar din vardag.</p>
          <div className="tb-about-actions">
            <a className="tb-button tb-button-primary" href={stockUrl}>Se våra bilar <span aria-hidden="true">↗</span></a>
            <a className="tb-button tb-button-outline" href="#contact">Besök oss <span aria-hidden="true">↓</span></a>
          </div>
        </div>
        <figure className="tb-about-hero-photo">
          <img src={exterior} alt="Fasaden och entrén till Touza Bilar i Södertälje" width="1600" height="1200" fetchpriority="high" />
          <figcaption><span aria-hidden="true">↗</span> Wedavägen 4C, Södertälje</figcaption>
        </figure>
      </section>

      <section className="tb-about-story" aria-labelledby="tb-about-story-title">
        <div className="tb-container tb-about-story-grid">
          <figure className="tb-about-showroom">
            <video controls autoPlay muted loop playsInline preload="metadata" poster={showroom} aria-label="Film från Touza Bilars bilhall">
              <source src={showroomVideo} type="video/mp4" />
              Din webbläsare kan inte spela filmen.
            </video>
            <figcaption>En inblick i vår bilhall. Aktuellt utbud finns på Blocket.</figcaption>
          </figure>
          <div className="tb-about-story-copy">
            <p className="tb-eyebrow">PERSONLIG KONTAKT, HELA VÄGEN</p>
            <h2 id="tb-about-story-title" className="tb-section-title">Din nästa bil.<br />På dina villkor.</h2>
            <p>Vi är ett familjeägt företag som tror på personlig service. Därför tar vi oss tid att lyssna på dina önskemål och hjälpa dig att hitta rätt.</p>
            <p>Oavsett om du vill köpa, sälja eller byta bil är du välkommen att ringa oss eller besöka vår bilhall i Södertälje.</p>
            <a className="tb-about-phone-link" href="tel:+46855066158">Prata med oss · 08-550 66 158 <span aria-hidden="true">↗</span></a>
          </div>
        </div>
      </section>

      <section id="contact" className="tb-about-contact tb-container" aria-labelledby="tb-about-contact-title">
        <div className="tb-about-contact-heading">
          <div>
            <p className="tb-eyebrow">KONTAKT & BESÖK</p>
            <h2 id="tb-about-contact-title" className="tb-section-title">Välkommen till oss.</h2>
          </div>
          <a className="tb-button tb-button-outline" href={directionsUrl}>Hitta hit <span aria-hidden="true">↗</span></a>
        </div>
        <div className="tb-about-contact-grid">
          <div className="tb-about-contact-card">
            <span className="tb-about-contact-number" aria-hidden="true">01</span>
            <h3>Ring oss</h3>
            <a className="tb-about-contact-value" href="tel:+46855066158">08-550 66 158</a>
            <p>Vi hjälper dig med dina frågor om att köpa, sälja eller byta bil.</p>
          </div>
          <div className="tb-about-contact-card">
            <span className="tb-about-contact-number" aria-hidden="true">02</span>
            <h3>Besök bilhallen</h3>
            <address className="tb-about-contact-value">Wedavägen 4C<br />152 42 Södertälje</address>
            <a className="tb-about-directions" href={directionsUrl}>Vägbeskrivning i Google Maps <span aria-hidden="true">↗</span></a>
          </div>
          <div className="tb-about-contact-card">
            <span className="tb-about-contact-number" aria-hidden="true">03</span>
            <h3>Öppettider</h3>
            <dl className="tb-about-hours">
              <div><dt>Måndag–fredag</dt><dd>09:30–17:30</dd></div>
              <div><dt>Lördag</dt><dd>11:00–15:00</dd></div>
            </dl>
          </div>
        </div>
      </section>
    </main>
    <Footer />
  </>
);

export default AboutScreen;
